const ART_PROPS = {
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};

const stroke = {
  stroke: "#1E293B",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const ArtStar = (p) => (
  <svg {...ART_PROPS} {...p}>
    <polygon points="100,25 121,78 177,80 132,114 148,170 100,138 52,170 68,114 23,80 79,78"
      fill="#fff" {...stroke} />
    <circle cx="88" cy="98" r="4" fill="#1E293B" />
    <circle cx="112" cy="98" r="4" fill="#1E293B" />
    <path d="M90,110 q10,10 20,0" {...stroke} fill="none" />
  </svg>
);

export const ArtArk = (p) => (
  <svg {...ART_PROPS} {...p}>
    <path d="M35,112 h130 l-18,42 h-94 Z" fill="#fff" {...stroke} />
    <path d="M78,112 v-30 h44 v30" fill="#fff" {...stroke} />
    <circle cx="100" cy="97" r="7" fill="#fff" {...stroke} />
    <path d="M60,82 q40,-44 80,0" fill="none" {...stroke} />
    <path d="M72,70 q28,-30 56,0" fill="none" {...stroke} strokeWidth="4" />
    <path d="M30,168 q10,-8 20,0 q10,8 20,0 q10,-8 20,0 q10,8 20,0 q10,-8 20,0 q10,8 20,0 q10,-8 20,0"
      fill="none" {...stroke} strokeWidth="4" />
  </svg>
);

export const ArtHeart = (p) => (
  <svg {...ART_PROPS} {...p}>
    <path d="M100,168 C45,122 32,74 64,57 C84,47 100,60 100,76 C100,60 116,47 136,57 C168,74 155,122 100,168 Z"
      fill="#fff" {...stroke} />
    <circle cx="86" cy="92" r="4" fill="#1E293B" />
    <circle cx="114" cy="92" r="4" fill="#1E293B" />
    <path d="M88,106 q12,10 24,0" {...stroke} fill="none" />
  </svg>
);

export const ArtSheep = (p) => (
  <svg {...ART_PROPS} {...p}>
    <ellipse cx="95" cy="112" rx="52" ry="36" fill="#fff" {...stroke} />
    <circle cx="60" cy="86" r="12" fill="#fff" {...stroke} />
    <circle cx="86" cy="78" r="12" fill="#fff" {...stroke} />
    <circle cx="112" cy="82" r="12" fill="#fff" {...stroke} />
    <circle cx="148" cy="104" r="18" fill="#fff" {...stroke} />
    <circle cx="143" cy="100" r="3.5" fill="#1E293B" />
    <path d="M150,112 q6,4 10,0" {...stroke} strokeWidth="4" fill="none" />
    <path d="M70,148 v18 M95,150 v18 M120,148 v18" {...stroke} />
  </svg>
);

export const ArtFish = (p) => (
  <svg {...ART_PROPS} {...p}>
    <ellipse cx="92" cy="108" rx="54" ry="36" fill="#fff" {...stroke} />
    <polygon points="140,108 178,80 178,136" fill="#fff" {...stroke} />
    <circle cx="70" cy="98" r="5" fill="#1E293B" />
    <path d="M52,122 q12,8 24,2" {...stroke} strokeWidth="4" fill="none" />
    <circle cx="60" cy="52" r="8" fill="#fff" {...stroke} strokeWidth="4" />
    <circle cx="84" cy="34" r="6" fill="#fff" {...stroke} strokeWidth="4" />
    <path d="M92,84 q10,24 0,48" fill="none" {...stroke} strokeWidth="4" />
  </svg>
);

export const ArtLion = (p) => (
  <svg {...ART_PROPS} {...p}>
    <circle cx="100" cy="102" r="62" fill="#fff" {...stroke} />
    <circle cx="100" cy="102" r="38" fill="#fff" {...stroke} />
    <circle cx="88" cy="94" r="4" fill="#1E293B" />
    <circle cx="112" cy="94" r="4" fill="#1E293B" />
    <polygon points="100,106 92,116 108,116" fill="#1E293B" />
    <path d="M92,122 q8,8 16,0" {...stroke} strokeWidth="4" fill="none" />
    <path d="M48,100 h-16 M152,100 h16 M56,78 l-12,-8 M144,78 l12,-8" {...stroke} strokeWidth="4" />
  </svg>
);

export const ArtMoon = (p) => (
  <svg {...ART_PROPS} {...p}>
    <path d="M124,28 A74,74 0 1,0 124,172 A58,58 0 1,1 124,28 Z" fill="#fff" {...stroke} />
    <polygon points="152,42 156,52 166,54 158,61 160,71 152,66 144,71 146,61 138,54 148,52"
      fill="#fff" {...stroke} strokeWidth="4" />
    <polygon points="170,120 173,128 181,130 175,135 176,143 170,139 164,143 165,135 159,130 167,128"
      fill="#fff" {...stroke} strokeWidth="4" />
    <circle cx="86" cy="96" r="4" fill="#1E293B" />
    <path d="M78,112 q10,10 22,4" {...stroke} strokeWidth="4" fill="none" />
  </svg>
);

export const BEDTIME_PRAYER =
  "Dear Jesus, thank You for today — for fun and friends and play. " +
  "Watch over me while I sleep, and all the ones I love. " +
  "Keep us safe till morning light. Amen.";

export const PACK_DAYS = [
  {
    day: 1,
    title: "God Made You Special",
    verse: "Psalm 139:14",
    verseText: "I praise you because I am fearfully and wonderfully made.",
    activity: "Stand together at a mirror and take turns finishing this sentence: “God made me special because…” — three answers each, giggles allowed.",
    song: { id: "god-made-me-special", title: "God Made Me Special" },
    color: "#FFC107",
    Art: ArtStar,
  },
  {
    day: 2,
    title: "Noah's Big Boat",
    verse: "Genesis 7:9",
    verseText: "The animals went in two by two, just as God had commanded.",
    activity: "March around the room two-by-two like the animals boarding the ark. Stomp like elephants, waddle like penguins, hop like bunnies!",
    song: { id: "noahs-animal-dance", title: "Noah's Animal Dance" },
    color: "#16A34A",
    Art: ArtArk,
  },
  {
    day: 3,
    title: "Thank You, God",
    verse: "1 Thessalonians 5:18",
    verseText: "Give thanks in all circumstances.",
    activity: "Trace your little one's hand on paper. On each finger, draw or write one thing you're thankful for — then say thank You together.",
    song: { id: "thank-you-god", title: "Thank You, God" },
    color: "#FF6B6B",
    Art: ArtHeart,
  },
  {
    day: 4,
    title: "Brave Little David",
    verse: "1 Samuel 17:45",
    verseText: "I come against you in the name of the Lord.",
    activity: "Roll up five socks as “smooth stones” and toss them at a laundry-basket giant. Every hit gets a cheer: “God helps me be brave!”",
    song: { id: "davids-little-stone", title: "David's Little Stone" },
    color: "#9333EA",
    Art: ArtSheep,
  },
  {
    day: 5,
    title: "Jonah and the Big Fish",
    verse: "Jonah 2:1",
    verseText: "From inside the fish, Jonah prayed to the Lord his God.",
    activity: "Build a blanket “big fish” den, crawl inside together, and say a little prayer — God hears us anywhere, even in a fish!",
    song: { id: "jonah-big-fish", title: "Jonah and the Big Fish" },
    color: "#0284C7",
    Art: ArtFish,
  },
  {
    day: 6,
    title: "Daniel and the Sleepy Lions",
    verse: "Daniel 6:22",
    verseText: "My God sent his angel, and he shut the mouths of the lions.",
    activity: "Practice Daniel's bedtime habit: kneel, fold hands, and each name one thing to talk to God about. Then roar as quietly as you can!",
    song: { id: "daniel-lions-den", title: "The Lions Didn't Bite" },
    color: "#16A34A",
    Art: ArtLion,
  },
  {
    day: 7,
    title: "Goodnight, Little One",
    verse: "Psalm 4:8",
    verseText: "In peace I will lie down and sleep, for you alone, Lord, make me dwell in safety.",
    activity: "Lights low, pyjamas on. Colour the moon, sing the song softly, then say the bedtime prayer together — a brand-new bedtime routine.",
    song: { id: "goodnight-jesus", title: "Goodnight Jesus" },
    color: "#9333EA",
    Art: ArtMoon,
    prayer: BEDTIME_PRAYER,
  },
];
